import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';
import { GET_PAYERS, SET_PAYER } from './constants';
import { getPayersSaga, setPayerSaga } from './sagas';

export const getPayers = (payload, onSuccess, onError) => {
  return createAction({
    type: GET_PAYERS,
    payload,
    meta: { onSuccess, onError, async: getPayersSaga },
  });
};

export const setPayer = (payload) => {
  return createAction({
    type: SET_PAYER,
    payload,
    meta: { async: setPayerSaga },
  });
};
